import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCopy } from "@/hooks/use-copy";

export function CopyButton({ text }: { text: string }) {
  const { copy, copied } = useCopy();

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={() => copy(text)}
    >
      {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
    </Button>
  );
}
